const SAME_DAY_ERRORS = {
  same_day_delivery_type:
    "Same Day delivery is currently unavailable for this store.",
  same_day_service_mismatch:
    "One or more selected services are not available for Same Day delivery.",
  same_day_date_mismatch:
    "Same Day pickup and delivery must be on the same date.",
  same_day_slot_invalid:
    "The selected Same Day slot is no longer available.",
  same_day_slot_sequence:
    "Please select a delivery slot after the pickup slot ends.",
  same_day_slot_full:
    "This Same Day slot is full. Please select another slot.",
  same_day_closed:
    "Same Day delivery is closed for the selected pickup slot.",
};

export const isSameDayDeliveryType = (type) =>
  Number(type?.is_same_day) === 1 ||
  type?.title?.trim().toLowerCase() === "same day";

export const buildSameDaySlotOptions = ({
  deliveryTypeId,
  type,
  pickupSlotId,
  pickupDate,
}) => ({
  deliveryTypeId,
  ...(type === 2 && pickupSlotId ? { pickupSlotId } : {}),
  ...(type === 2 && pickupDate ? { pickupDate } : {}),
});

export const getSameDayErrorMessage = (code) =>
  SAME_DAY_ERRORS[code] ||
  "Same Day delivery could not be placed. Please review the selected slots.";

